export default {
  title: 'list orders',
  search: 'search ...',
  id: 'id',
  studentName: 'student',
  studentMobile: 'mobile',
  subtotal: 'subtotal',
  totalDiscount: 'total discount',
  totalPrice: 'total price',
  shippingMethod: 'shipping method',
  paymentMethod: 'payment method',

  status: 'status',
  statusRegistered: 'registered',
  statusApproved: 'approved',
  changeStatus: "Change Order Status",
  confirm: "Confirm",
  cancel: "Cancel",
  approveOrder: "Approve Order",
  rejectOrder: "Reject Order",
  changeStatusBtn: "Change Status",
  statusRejected: 'rejected',
  loading: 'loading ... ',
  operating: 'operating',
  empty: 'list is empty',
  next: 'Next',
  previous: 'Previous',
  success: 'success',
}
